import { useMemo } from 'react';
import { useInstallmentsCheckoutProvider } from '@/hooks/useInstallmentsCheckoutProvider';
import { getInstallmentsCopy } from '@/utils/installmentsCopy';

/** User-facing installment partner language (Slice Pay vs Defera Capital) from platform setting. */
export function useInstallmentsCopy() {
  const provider = useInstallmentsCheckoutProvider();
  return useMemo(
    () => getInstallmentsCopy(provider === 'defera_capital'),
    // null = loading; show Slice copy until provider resolves (brief)
    [provider]
  );
}
